import { CalendarTwoTone, CheckCircleTwoTone, CheckOutlined, CloseCircleTwoTone, HourglassTwoTone, SolutionOutlined } from "@ant-design/icons";
import { Avatar, Tag, Tooltip } from "antd";
import dayjs from "dayjs";
import { HiOutlineCheckBadge } from 'react-icons/hi2';

const dateFormat = "DD-MM-YYYY"

export const formatDate = (value) => {
    const formattedDate = dayjs(value).format('DD-MM-YYYY')
    return formattedDate;
}
export const isoFormatDate = (value) => {
    const formattedDate = dayjs(value).format('YYYY-MM-DD')
    return formattedDate;
}

export const getApplicationType = (status) => {
    switch (status) {
        case 'new':
            return <Tag color='blue' className="text-capitalize">{status}</Tag>;
        default:
            return <Tag color='volcano' className="text-capitalize">{status}</Tag>;
    }
}

/* export const getStatusTag = (status) => {
    switch (status) {
        case 'approved':
            return <strong className="fw-semibold" style={{ color: '#52c41a' }}><CheckCircleTwoTone twoToneColor="#52c41a" /> Approved</strong>;
        case 'rejected':
            return <strong className="fw-semibold" style={{ color: '#ff0000' }}><CloseCircleTwoTone twoToneColor="#ff0000" /> Rejected</strong>;
        case 'pending':
            return <Tooltip title="This application is under review"><strong className="fw-semibold" style={{ color: '#005BE5' }}><HourglassTwoTone style={{ color: '#005BE5' }} /> Pending</strong></Tooltip>
        case 'scheduled':
            return <Tooltip title="This application is Scheduled"><strong className="fw-semibold" style={{ color: '#800080' }}><CalendarTwoTone style={{ color: '#800080' }} /> Scheduled</strong></Tooltip>
        case 'completed':
            return <Tooltip title="This application is Completed"><strong className="fw-semibold" style={{ color: '#FCC666' }}><CheckCircleTwoTone style={{ color: '#FCC666' }} /> Completed</strong></Tooltip>
        default:
            return '';
    }
} */

export const getStatusTag = (status) => {
    switch (status) {
        case 'completed':
            return <strong className="fw-semibold" style={{ color: '#00BA13' }}><CheckOutlined style={{ color: "#00BA13" }} /> Completed</strong>;
        case 'scheduled':
            return <strong className="fw-semibold" style={{ color: '#2662FC' }}><CalendarTwoTone twoToneColor="#2662FC" /> Scheduled</strong>;
        case 'rejected':
            return <strong className="fw-semibold" style={{ color: '#E82A2A' }}><CloseCircleTwoTone twoToneColor="#E82A2A" /> Rejected</strong>;
        case 'approved':
            return <strong className="fw-semibold" style={{ color: '#39E2D8' }}><CheckCircleTwoTone twoToneColor="#39E2D8" /> Approved</strong>;
        case 'pending':
            return <Tooltip title="This application is under review"><strong className="fw-semibold" style={{ color: '#848484' }}><HourglassTwoTone style={{ color: '#848484' }} /> Pending</strong></Tooltip>
        case 'confirmed':
            return <strong className="fw-semibold" style={{ color: '#3a5a40' }}><HiOutlineCheckBadge className='anticon' style={{ color: '#3a5a40' }} /> Confirmed</strong>
        default:
            return '';
    }
}

export const getApplicationId = (id) => {
    return 'ATS-' + id
}

function validateName(name) {
    return name !== undefined && name !== "" && name !== null
}

const hRange = [0, 360];
const sRange = [20, 75];
const lRange = [30, 75];

const normalizeHash = (hash, min, max) => {
    return Math.floor((hash % (max - min)) + min);
};

const getHashOfString = (str) => {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    hash = Math.abs(hash);
    return hash;
}

export function getFirstInitials(value) {
    const splitValue = value.split(' ');
    let initialValue = ''
    splitValue.map(item => {
        initialValue = initialValue + item.substring(0, 1);
    })

    return initialValue;
}

export function generateColorByString(name) {
    const hash = getHashOfString(name);
    const h = normalizeHash(hash, hRange[0], hRange[1]);
    const s = normalizeHash(hash, sRange[0], sRange[1]);
    const l = normalizeHash(hash, lRange[0], lRange[1]);

    const hsl = [h, s, l]

    return `hsl(${hsl[0]}, ${hsl[1]}%, ${hsl[2]}%)`;
}

export function AvatarText({ name, size }) {
    return (
        validateName(name) ?
            <Tooltip title={name} placement="right">
                <Avatar size={size} className='custom-avatar' style={{ backgroundColor: generateColorByString(name) }}>{getFirstInitials(name)}</Avatar>
            </Tooltip>
            : ''
    )
}

export function formatDateTime(value) {
    return dayjs(value).format(`${dateFormat} h:mm a `);
}



export const timeFormate = (value) => {
    const formattedDate = dayjs(value).format('hh:mm')
    return formattedDate;
}

export const timeFormate12 = (value) => {
    const formattedDate = dayjs(value).format("hh:mm A")
    return formattedDate;
}

export const trucatePercentage = (num) => num.slice(0, (num.indexOf(".")) + 3);

export { dateFormat }